"use client"

import * as React from "react"
import { cn } from "@/lib/utils"

/**
 * VisuallyHidden component
 * 
 * Hides content visually while keeping it accessible to screen readers
 * This follows best practices for accessibility
 */
const VisuallyHidden = React.forwardRef<
  HTMLSpanElement,
  React.HTMLAttributes<HTMLSpanElement>
>(({ className, ...props }, ref) => {
  return (
    <span
      ref={ref}
      className={cn(
        "absolute h-px w-px p-0 overflow-hidden whitespace-nowrap border-0",
        // This ensures content is visually hidden but accessible to screen readers
        "clip-[rect(0,0,0,0)] [clip-path:inset(50%)]", 
        className
      )}
      {...props}
    />
  )
})
VisuallyHidden.displayName = "VisuallyHidden"

export { VisuallyHidden }
